import api from "@/modules/notifications/plugins/notification";
import { makeNotification } from '@/modules/notifications/plugins/errors';


const state = () => ({
    notification: false,
    notifications:[],
    showPanel: false,
    counter: 0, 
    hasNotification: false
})

const getters = {
    isPanelShow(state){
        return state.showPanel
    }
}

const actions = {
    loadNotifications({ commit },payload){
        api.getNotifications(payload)
            .then((r)=>{
                commit('LOAD_NOTIFICATION',r.data)
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    diplayNotification({ commit }, payload){
        commit('ADD_NOTIFICATION',payload)
    },
    postToChannel({ commit,rootState }, payload){
        let pdv = []
        let idExt = payload.id ? payload.id : ""
        rootState.outlets.outlets.map(x => pdv.push(x.denomination))
        const notification = makeNotification({ code: payload.code, extra: payload.extra, pdv: pdv, id: idExt })
        api.postChannel(notification)
            .then((r)=>{
                api.postNotification(r.data)
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    saveHasRead({ commit }, payload){
        api.hasRead(payload.id)
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    markHasRead({ commit, dispatch },payload){
        dispatch('saveHasRead',payload)
        commit('HIDE_NOTIFICATION',payload)
    },
    
    /** Undefined used */
    deleteNotification({ commit }, id){
        api.deleteNotification(id)
            .then((r)=>{
                commit('DELETE_NOTIFICATION',r.data)
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    
}

const mutations = {
    ADD_NOTIFICATION (state, notification) {
        state.notifications.push(notification)
        state.hasNotification = true
    },
    
    HIDE_NOTIFICATION(state,payload) {
        state.hasNotification = false
        const obj = state.notifications.find(x => x.uuid === payload.uuid)
        obj.isRead = true
    },
    LOAD_NOTIFICATION(state,payload) {
        state.notifications = payload
    },
    DELETE_NOTIFICATION (state, id){
        const index = state.notifications.findIndex(c => c.id === id);
        state.notifications.splice(index, 1);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
